import {useContext, useEffect, useRef, useState} from "react";
import {LoadingContext, PageContext, ToastContext, UserContext} from "../../contexts";
import {BancoApi, SetorApi} from "../../apis";
import {FaBusinessTime, FaTimes} from "react-icons/fa";
import Logo from "../../assets/img/logo-h.png";
import {Paginacao} from "../../components";
import {useLocation} from "react-router";
import {LocalizationProvider, MobileDatePicker} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {ptBR} from "date-fns/locale";
import {TextField} from "@mui/material";

export const BancoHoras = () => {
  const docRef = useRef();
  const {user} = useContext(UserContext);
  const {pageInfo, setPageInfo} = useContext(PageContext);
  const [carregado, setCarregado] = useState(false);
  const [itens, setItens] = useState(null);
  const [modal, setModal] = useState(false);
  const [itemView, setItemView] = useState(null);
  const [pagina, setPagina] = useState(1);
  const [paginacaoInfo, setPaginacaoInfo] = useState(null);
  const {setLoading} = useContext(LoadingContext);
  const location = useLocation();
  const [ordem, setOrdem] = useState('DESC');
  const [listaSetor, setListaSetor] = useState([]);
  const [divFiltro, setDivFiltro] = useState(false);
  const [filtro, setFiltro] = useState({});

  const [dataInicio, setDataInicio] = useState(null);
  const [dataFim, setDataFim] = useState(null);
  const [dataForm, setDataForm] = useState(null);

  const mes = ['','Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

  const toasts = useContext(ToastContext);
  const AddToast = (item) => {
    let tempArr = [...toasts.toast];
    tempArr.push(item);
    toasts.setToast({toast: tempArr, setToast: toasts.setToast});
  }

  const load = async () => {
    setLoading(true);
    try {
      let respostaSetor = await SetorApi.get();
      if (!respostaSetor.error) {
        let tempArr = [{uuid: '', titulo: "Nenhum filtro"}];
        respostaSetor.data.forEach((item) => {
          tempArr.push(item)
        });
        setListaSetor(tempArr);
      } else {
        AddToast({texto: "Falha ao carregar setores!", tipo: "erro"});
      }
    } catch (e) {
      AddToast({texto: e, tipo: "erro"});
    }
    let search = null;
    let resultadoGet;
    try {
      if (typeof location.state.search !== 'undefined') {
        search = (location.state.search);
      }
    } catch (e) {
    }
    try {
      if (search !== null) {
        resultadoGet = await BancoApi.getAllSearch(user.uuid, pagina, search);
      } else {
        resultadoGet = await BancoApi.getAll(user.uuid, pagina, ordem, filtro, dataForm);
      }
      if (!resultadoGet.error) {
        setItens(resultadoGet.data);
        setPaginacaoInfo(resultadoGet.paginacao);
        setCarregado(true);
        setLoading(false);
      } else {
        AddToast({texto: resultadoGet.error, tipo: "erro"});
        setLoading(false);
      }
    } catch (e) {
      AddToast({texto: e, tipo: "erro"});
      setLoading(false);
    }
    setLoading(false);
  }

  useEffect(() => {
    load()
  }, [pagina]);

  if (!carregado) {
    load();
    setPageInfo(
      {
        ...pageInfo,
        titulo: 'Banco de Horas',
        icone: <FaBusinessTime size={30}/>
      }
    );
    setCarregado(true);
  }

  const openCi = async (uuid) => {
    setLoading(true);
    try {
      let resultadoGetItem = await BancoApi.getItem(user.uuid, uuid);
      if (!resultadoGetItem.error) {
        setItemView(resultadoGetItem.data);
        setModal(true);
        setLoading(false);
      } else {
        AddToast({texto: resultadoGetItem.error, tipo: "erro"});
        setLoading(false);
      }
    } catch (e) {
      AddToast({texto: e, tipo: "erro"});
      setLoading(false);
    }
  }

  const excluirBanco = async (uuid) => {
    setLoading(true);
    try {
      let resultadoGetItem = await BancoApi.delete(user.uuid, uuid);
      if (!resultadoGetItem.error) {
        AddToast({texto: "Sucesso!", tipo: "sucesso"});
        load();
        setLoading(false);
      } else {
        AddToast({texto: resultadoGetItem.error, tipo: "erro"});
        setLoading(false);
      }
    } catch (e) {
      AddToast({texto: e, tipo: "erro"});
      setLoading(false);
    }
  }

  const filtroDeData = async () => {
    if (dataInicio && dataFim) {
      if (dataInicio > dataFim) {
        let tempData = dataInicio;
        setDataInicio(dataFim);
        setDataFim(tempData);
      } else {
        setDataForm({
          inicio: `${dataInicio.getFullYear()}-${(dataInicio.getMonth()+1) < 10 ? '0' + (dataInicio.getMonth()+1) : (dataInicio.getMonth()+1)}-${dataInicio.getDate()}`,
          fim: `${dataFim.getFullYear()}-${(dataFim.getMonth()+1) < 10 ? '0' + (dataFim.getMonth()+1) : (dataFim.getMonth()+1)}-${dataFim.getDate()}`
        });
      }
    }
  }

  useEffect(() => {
    filtroDeData();
  }, [dataInicio, dataFim]);

  useEffect(() => {
    load()
  }, [ordem, filtro, dataForm]);

  const setAsc = () => {
    setOrdem('ASC');
  }

  const setDesc = () => {
    setOrdem('DESC');
  }

  const toggleDivFiltro = () => {
    setDivFiltro(!divFiltro);
  }

  const filtrar = (nomeFiltro, valorFiltro) => {
    setFiltro({...filtro, [nomeFiltro]: valorFiltro});
  }

  const limparFiltro = () => {
    setFiltro({});
    setDivFiltro(false);
    setDataForm(null);
    setDataInicio(null);
    setDataFim(null);
  }

  const toggleVisto = async (uuid) => {
    setLoading(true);
    try {
      let resultadoGetItem = await BancoApi.toggleVisto(user.uuid, uuid);
      if (!resultadoGetItem.error) {
        AddToast({texto: "Sucesso!", tipo: "sucesso"});
        load();
        setLoading(false);
      } else {
        AddToast({texto: resultadoGetItem.error, tipo: "erro"});
        setLoading(false);
      }
    } catch (e) {
      AddToast({texto: e, tipo: "erro"});
      setLoading(false);
    }
  }

  return (
    <div className="publicacao ci">
      {itens &&
        <div className="painel-itens">
          <div className="botoes">
            <div className="ordenacao">
              <span>Ordenar por:</span>
              <div className={ordem === 'DESC' ? "btn btn-primary" : "btn btn-secondary"} onClick={setDesc}>
                Mais recentes
              </div>
              <div className={ordem === 'ASC' ? "btn btn-primary" : "btn btn-secondary"} onClick={setAsc}>
                Mais antigas
              </div>
            </div>
            <div className="filtro">
              <div className="btn btn-editar" onClick={toggleDivFiltro}>
                Filtrar
              </div>
              {divFiltro &&
                <div className="float">
                  <div className="btn btn-primary"
                       onClick={() => {
                         limparFiltro()
                       }}>
                    Limpar
                  </div>
                  {listaSetor.length > 0 &&
                    <div className="seletor">
                      <label>Setor:</label>
                      <select onChange={(e) => {
                        filtrar('setor', e.target.value);
                        setDivFiltro(false);
                      }}>
                        {listaSetor.map((item) => (
                          <option key={item.uuid} selected={filtro.setor === item.uuid}
                                  value={item.uuid}>{item.titulo}</option>
                        ))}
                      </select>
                    </div>
                  }

                  <div className="seletor">
                    <label>Tipo:</label>
                    <select onChange={(e) => {
                      filtrar('tipo', e.target.value);
                      setDivFiltro(false);
                    }}>
                      <option selected={filtro.tipo === ""} value="">Nenhum filtro</option>
                      <option selected={filtro.tipo === "Autorização"} value="Autorização">Autorização</option>
                      <option selected={filtro.tipo === "Compensação"} value="Compensação">Compensação</option>
                    </select>
                  </div>

                  {(user.nivel === 'rh' || user.nivel.includes('admin')) &&
                    <div className="seletor">
                      <label>Visto:</label>
                      <select onChange={(e) => {
                        filtrar('visto', e.target.value);
                        setDivFiltro(false);
                      }}>
                        <option selected={filtro.visto === ""} value="">Nenhum filtro</option>
                        <option selected={filtro.visto === "1"} value="1">Sim</option>
                        <option selected={filtro.visto === "0"} value="0">Não</option>
                      </select>
                    </div>
                  }

                  <span className={"label-novo"}>Data entre:</span>
                  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                    <MobileDatePicker
                      value={dataInicio}
                      onChange={(newValue) => {
                        setDataInicio(newValue);
                      }}
                      renderInput={(params) => <TextField fullWidth {...params} />}
                    />
                    <span className={"label-novo"}>e</span>
                    <MobileDatePicker
                      value={dataFim}
                      onChange={(newValue) => {
                        setDataFim(newValue);
                      }}
                      renderInput={(params) => <TextField fullWidth {...params} />}
                    />
                  </LocalizationProvider>
                </div>
              }
            </div>
          </div>
          <div className="arquivo">
            {itens.map((item) => (
              <div key={item.uuid} className="arquivo-item">
                <div className="publicacao-info d-flex direction-column" style={{alignItems: "normal"}}>
                  <div className="publicacao-info">
                    <div className="data">
                      {item.dia + "/" + item.mes + "/" + item.ano}
                    </div>
                    <div className="titulo">
                      {item.titulo}
                    </div>
                  </div>
                  <div className="info">
                    <span><b>Setor:</b> {item.setor}</span>
                    <span><b>Tipo:</b> {item.tipo}</span>
                    <span><b>Solicitante:</b> {item.solicitante}</span>
                  </div>
                </div>
                <div className="opcoes">
                  {(user.nivel === 'rh' || user.nivel.includes('admin')) &&
                    <div className={item.visto ? "btn btn-enviar" : "btn btn-editar"} onClick={() => {
                      toggleVisto(item.uuid)
                    }}>
                      {item.visto ? 'Visto' : 'Não visto'}
                    </div>
                  }
                  <div className="btn btn-cancelar" onClick={() => {
                    openCi(item.uuid)
                  }}>
                    Visualizar
                  </div>
                  {(user.nivel === 'rh' || user.nivel.includes('admin')) &&
                    <div className="btn btn-primary" onClick={() => {
                      excluirBanco(item.uuid)
                    }}>
                      Excluir
                    </div>
                  }
                </div>
              </div>
            ))}
          </div>
          <Paginacao pagina={pagina} setPagina={setPagina} info={paginacaoInfo}/>
        </div>
      }

      {modal &&
        <div className="tela-modal-preview">
          <div className="modal">
            <div className="modal-preview-cabecalho">
              <div className="titulo">
                <FaBusinessTime size={30}/>
                <span>Banco de Horas</span>
              </div>
              <div className="d-flex">
                <div className="btn btn-secondary" onClick={window.print}>
                  Imprimir
                </div>
                <div className="btn btn-primary" onClick={() => {
                  setModal(false)
                }}>
                  Fechar(<FaTimes style={{marginRight: 0}}/>)
                </div>
              </div>
            </div>
            <div className="documento" ref={docRef}>
              <img className="logo-documento" src={Logo} alt="Logo Nunes Peixoto"/>
              <span className="titulo" style={{textTransform: "uppercase"}}>{itemView.tipo} Para Banco de Horas</span>
              <span className="linha">Setor: <span className="valor">{itemView.setor}</span></span>

              <table className={"tabela"}>
                <tr>
                  <th>Matrícula</th>
                  <th>Colaborador</th>
                  <th>Horas</th>
                  <th>Data</th>
                </tr>
                {itemView.lista.length > 0 && itemView.lista.map((linha, index) => (
                  <tr key={index}>
                    <td>{linha.matricula}</td>
                    <td>{linha.funcionarioNome}</td>
                    <td>{linha.hora}</td>
                    <td>{linha.data}</td>
                  </tr>
                ))}
              </table>

              <span className="linha">Itabaiana, <span className="valor">{itemView.dia}</span> de <span
                className="valor">{mes[itemView.mes]}</span> de <span className="valor">{itemView.ano}</span></span>
              <span className="centro"><span className="valor">{itemView.solicitante}</span></span>
              <span className="centro">Assinatura do solicitante</span>
            </div>
          </div>
        </div>
      }
    </div>
  );
}